var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeopen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4974 0.445312C6.28906 0.445312 1.84115 3.29615 0.0390625 7.32031C1.84115 11.3445 6.28906 14.1953 11.4974 14.1953C16.7057 14.1953 21.1537 11.3445 22.9557 7.32031C21.1537 3.29615 16.7057 0.445312 11.4974 0.445312ZM11.4974 11.9036C8.6224 11.9036 6.28906 9.85031 6.28906 7.32031C6.28906 4.79031 8.6224 2.73698 11.4974 2.73698C14.3724 2.73698 16.7057 4.79031 16.7057 7.32031C16.7057 9.85031 14.3724 11.9036 11.4974 11.9036ZM11.4974 4.57031C9.76823 4.57031 8.3724 5.79865 8.3724 7.32031C8.3724 8.84198 9.76823 10.0703 11.4974 10.0703C13.2266 10.0703 14.6224 8.84198 14.6224 7.32031C14.6224 5.79865 13.2266 4.57031 11.4974 4.57031Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeopen);
export default __webpack_public_path__ + "static/media/eyeopen.73ae9ce8a38c824432e6f3a6f5371fb7.svg";
export { ForwardRef as ReactComponent };